import { useCallback } from 'react'
import { useParams, generatePath } from 'react-router-dom'
import styled from 'styled-components'

import { useApiQuery } from 'admin/lib/Api'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { GetPageNames } from 'admin/lib/GetPageNames'
import { Layout } from 'admin/lib/Layouts'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'

import { EditProject } from './EditProject'

export function ProjectPage() {
  const { accountId, projectId: paramsProjectId } = useParams()

  const NEW_PROJECT_ID = 'new'
  const projectId = paramsProjectId || NEW_PROJECT_ID

  const project = useApiQuery(
    useCallback(
      api => {
        if (projectId === NEW_PROJECT_ID) {
          return [{}, null, null]
        }
        return api.getProject(accountId, projectId)
      },
      [accountId, projectId]
    )
  )

  const pageNames = GetPageNames(accountId)

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={generatePath(ROUTES.ACCOUNTS.LIST)}>
                  Accounts
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  {pageNames.data && pageNames.data.accountName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem>
                  {projectId === NEW_PROJECT_ID
                    ? 'New Project'
                    : project.data?.name}
                </BreadcrumbArrayItem>
              )
            }
          ]}
        />
      }
    >
      {(!project.loaded) && (
        <ScreenSpin />
      )}

      {project.loaded && (
        <EditSection>
          <EditProject
            project={project.data}
            isNew={projectId === NEW_PROJECT_ID}
            accountId={accountId}
            projectId={projectId}
          />
        </EditSection>
      )}
    </Layout>
  )
}

const EditSection = styled.div`
  margin: 0 auto;
  width: 60rem;
`
